/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Link } from "react-router-dom";

import logo2 from "./../../images/Site1.jpeg";
import { useSelector } from "react-redux";

export const Header = () => {
  const isLogin = localStorage.getItem("userDetails");
  console.log(isLogin, "isLogin");

 
  const Details = useSelector((state) => state.auth.auth);
  console.log(Details);

  return (
    <>
      <header className="site-header mo-left header fullwidth">
        <div className="sticky-header main-bar-wraper navbar-expand-lg">
          <div className="main-bar clearfix">
            <div className="container clearfix">
              <div className="logo-header mostion">
                <Link to={"/"}>
                  <img
                    src={logo2}
                    className="logo mb-1"
                    width="100%"
                    alt="img"
                  />
                </Link>
              </div>

             
              <div className="extra-nav mt-3">
                {isLogin ? (
                  <div className="extra-cell">
                    <Link to={"/profile"} className="site-button">
                      <i className="fa fa-user"></i>
                      &nbsp;
                      {Details?.user?.first_name
                        ? Details?.user?.first_name
                        : "Profile"}
                    </Link>
                  </div>
                ) : (
                  <>
                    <div className="extra-cell">
                      <Link to={"/login"} className="site-button">
                        <i className="fa fa-user"></i>&nbsp;User Login
                      </Link>
                    </div>
                    <div className="extra-cell">
                      <a href="http://talentoftheworldprofessional.dev-bt.xyz/" className="site-button">
                        <i className="fa fa-user"></i>&nbsp;Employer Login
                      </a>
                    </div>
                  </>
                )}
              </div>

              {/* <div
                className="header-nav navbar-collapse collapse myNavbar justify-content-start mt-2"
                id="navbarNavDropdown"
              >
                <div className="logo-header mostion d-md-block d-lg-none">
                  <Link to={"/"} className="dez-page ">
                    <img src={logo2} alt=""  height={'50px'}/>
                  </Link>
                </div>
                {isLogin ? (
                  <ul className="nav navbar-nav">
                    <li className="">
                      <Link to="/" style={{backgroundColor:'#FC1210',color:'white'}}>
                        Job
                        <i className="fa fa-chevron-down"></i>
                      </Link>
                      <ul className="sub-menu">
                        {data?.map((item) => (
                          <li>
                            <Link
                              to={"/browse-job-filter-list"}
                              className="dez-page"
                            >
                              {item.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                    <li>
                      <Link to={"#"} style={{backgroundColor:'#FC1210',color:'white'}}>Resources</Link>
                    </li>
                  </ul>
                ) : null}
              </div> */}
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
export default Header;
